import React, { useState, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';

import PeopleIcon from '@mui/icons-material/People'; // For UserMaster
import InventoryIcon from '@mui/icons-material/Inventory'; // For ProductMaster

import AdminNavbar from './AdminNavbar';
import { Outlet } from 'react-router-dom';

import Icon from '@mui/material/Icon';
import { ContactIcon, PhoneIcon } from 'lucide-react';
const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => setIsOpen((prev) => !prev);

  const menuItems = useMemo(
    () => [
      {
        path: '/admin',
        name: 'UserMaster',
        icon: <PeopleIcon className='mr-2' />,
      },
      {
        path: '/admin/productmaster',
        name: 'ProductMaster',
        icon: <InventoryIcon className='mr-2' />,
      },
      {
        path: '/admin/ordermaster',
        name: 'OrderMaster',
        icon: <InventoryIcon className='mr-2' />,
      },
      {
        path: '/admin/contactmaster',
        name: 'ContactMaster',
        icon: <ContactIcon className='mr-2' />,
      },
    ],
    []
  );

  return (
    <div className='flex'>
      <div className='flex'>
        <aside
          className={`bg-white text-black shadow-lg top-0 left-0 h-screen p-4 m-5 rounded-3xl transition-all duration-300 flex flex-col ${
            isOpen ? 'w-64' : 'w-20'
          }`}
        >
          {/* Sidebar Header */}
          <div
            className={`flex items-center justify-between ${
              isOpen ? 'mb-8' : 'mb-0'
            } transition-all duration-300`}
          >
            <div className='flex items-center space-x-3'>
              {isOpen && (
                <span className='text-2xl font-semibold'>
                Pralhad Flours Admin panel
                </span>
              )}
            </div>
            <button
              onClick={toggleSidebar}
              className='p-2 rounded-md bg-gray-200 hover:bg-gray-300 transition ml-3'
              aria-label='Toggle sidebar'
            >
              <MenuIcon />
            </button>
          </div>

          {/* Navigation */}
          <nav className='flex-grow mt-4 overflow-y-auto'>
            <ul className='space-y-4'>
              {menuItems.map(({ path, name, icon }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className={`flex items-center px-3 py-3 text-base rounded-lg ${
                      location.pathname === path
                        ? 'bg-amber-500 text-white'
                        : 'text-black hover:bg-amber-200'
                    }`}
                  >
                    {icon}
                    <span
                      className={`transition-all duration-300 ${
                        !isOpen && 'hidden'
                      }`}
                    >
                      {name}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </aside>
      </div>
      <div className='flex-grow'>
        <AdminNavbar />

        <main className='flex-1 p-4 overflow-auto'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Sidebar;
